export default __webpack_public_path__ + "assets/9081c7916d9eea172eaaba60456fe674.png";